import React from "react";
import { Link } from "react-router-dom";
import { resolveWorkspaceNav, startWorkspaceHandoff } from "./workspaceRegistry";
import WorkspaceIcon from "./WorkspaceIcon";

/**
 * Single permission-driven workspace navigation renderer.
 */
function WorkspaceNav({
  workspace,
  caps,
  section,
  onSelectSection,
  onHandoff,
  compact,
  hiddenIds,
}) {
  const hidden = Array.isArray(hiddenIds) ? hiddenIds : [];
  const items = resolveWorkspaceNav(workspace, caps).filter(
    (item) => hidden.indexOf(item.id) < 0
  );

  const handleClick = (item, e) => {
    if (e) e.preventDefault();
    const t = item.target;
    if (!t) return;
    if (t.type === "section") {
      if (onSelectSection) onSelectSection(t.value);
      return;
    }
    if (t.type === "soon") {
      if (onSelectSection) onSelectSection("soon:" + t.value);
      return;
    }
    if (t.type === "route") {
      if (typeof window !== "undefined") {
        window.location.assign(t.value);
      }
      return;
    }
    if (t.type === "handoff") {
      if (onHandoff) onHandoff(item);
      else if (workspace && workspace.bladeHandoff) {
        startWorkspaceHandoff(workspace);
      }
    }
  };

  return (
    <nav
      className={"ws-nav" + (compact ? " ws-nav--compact" : "")}
      aria-label="Workspace"
    >
      {items.map((item, idx) => {
        const active =
          section === item.target.value ||
          section === "soon:" + item.target.value ||
          (item.target.type === "section" && section === item.target.value);
        const key = item.id + "-" + idx;
        if (item.target.type === "route") {
          return (
            <Link
              key={key}
              className={"ws-nav__item" + (active ? " is-active" : "")}
              to={item.target.value}
            >
              <WorkspaceIcon name={item.icon || (workspace && workspace.icon)} />
              <span>{item.label}</span>
            </Link>
          );
        }
        return (
          <button
            key={key}
            type="button"
            className={"ws-nav__item" + (active ? " is-active" : "")}
            onClick={(e) => handleClick(item, e)}
          >
            <WorkspaceIcon name={item.icon || (workspace && workspace.icon)} />
            <span>{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}

export default WorkspaceNav;
